import { IRoleTypeService } from "../../service/role/RoleTypeService";

export default class RemoveRoleTypePositionTypesInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(roleTypePositionTypeIds: string[]) {
    return this.roleTypeService.removeRoleTypePositionTypes(
      roleTypePositionTypeIds
    );
  }
}
